// extracted by mini-css-extract-plugin
export default {"banner":"SuccessStep_banner__Zb+Zw","checkIcon":"SuccessStep_checkIcon__8bAMe"};